
export enum UserRolesEnum {
  Requester = 'TX_ROLE_BUYER_REQUESTER',
  Procurement = 'TX_ROLE_BUYER_PROCUREMENT',
  Admin = 'TX_ROLE_BUYER_ADMIN',
  Owner = 'TX_ROLE_BUYER_OWNER',
}
export const UserRoles = {
  Requester: 'TX_ROLE_BUYER_REQUESTER',
  Procurement: 'TX_ROLE_BUYER_PROCUREMENT',
  Admin: 'TX_ROLE_BUYER_ADMIN',
  Owner: 'TX_ROLE_BUYER_OWNER',
};

export interface User {
  _id: string;
  email: string;
  first_name: string;
  last_name: string;
  state: string;
  mobile_number: string;
  job_title: string;
  user_type: string;
  customerId: string;
  lang: string;
  formattedName?: string;
  txRole?: UserRolesEnum;
}
